import React from 'react';
import {
  Box,
  Container,
  Card,
  CardContent,
  Typography,
  Button,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';

const SuccessPage = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate('/login'); // adjust this route to your actual login path
  };

  return (
    <Container maxWidth="sm">
      <Box mt={12} display="flex" justifyContent="center">
        <Card sx={{ width: '100%', textAlign: 'center', padding: 4, boxShadow: 3 }}>
          <CardContent>
            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Password Reset Successful
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={3}>
              You can now log in with your new password.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                mt: 3,
                height: 48,
                borderRadius: 2,
                fontWeight: 600,
                textTransform: "none",
                color: "#fff",
                background: "linear-gradient(90deg, #495057 0%, #212529 100%)",
                boxShadow: "0px 3px 6px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "#343a40",
                  boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
                  transform: "translateY(-1px)",
                },
              }}
              onClick={handleGoToLogin}
            >
              Go to Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default SuccessPage;
